import { EventEmitter } from 'events';
export const NoticeEmitter = new EventEmitter();